const data = [
    {
        id: 1,
        title: "Technical Content Writer @ Career360",
        duration: "June 2021 - April 2022",
        desc: "Writing technical articles and blogs to their main website. Solving queries of students related to their careers. Answering questions and clearing doubts of students in the QnA portal.",
        company: "Careeer360",
    },
    {
        id: 2,
        title: "Graphic Designer @Purple Brick",
        duration: "November 2021 - March 2022",
        desc: "Designing the front-end UI/UX of the client's websites. Responsible for Designing and creating graphics, banners, logos, and templates for various social media platforms.",
        company: "Purple Brick",
    },
    // {
    //     id: 3,
    //     title: "Web developer @Sarvvid AI",
    //     duration: "Oct 2022 - Dec 2022",
    //     desc: "I have built modern and performant websites and E-commerce platforms for various clients on various topics. Worked with a variety of different languages, frameworks, and content management systems such as JavaScript, TypeScript, React, ExpressJS and Node.js. Collaborated with disciplinary teams of engineers on a daily basis",
    //     company: "Sarvvid AI",
    // },
    // {
    //     id: 4,
    //     title: "Frontend Web Developer@ Brandshark",
    //     duration: "March 2022 - June 2022",
    //     desc: "Developed and maintained code for in-house and client websites primarily using HTML, CSS, Sass, JavaScript, and jQuery. Manually tested sites in various browsers and mobile devices to ensure cross-browser compatibility and responsiveness.",
    //     company: "Brandshark",
    // },
]

export default data;